import { render, staticRenderFns } from "./CommonTable.vue?vue&type=template&id=5716d07c&scoped=true"
import script from "./CommonTable.vue?vue&type=script&lang=js"
export * from "./CommonTable.vue?vue&type=script&lang=js"
import style0 from "./CommonTable.vue?vue&type=style&index=0&id=5716d07c&prod&scoped=true&lang=css"
import style1 from "./CommonTable.vue?vue&type=style&index=1&id=5716d07c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5716d07c",
  null
  
)

export default component.exports